.grid {
  padding-top: 8px;
  padding-bottom: 32px;
}

.list {
  max-height: 40vh;
  overflow-y: auto;
  padding-bottom: 96px;
  mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
}
